// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2RYbn","title":"Info_title__33K_0","selects":"Info_selects__1mhoL","requiredAsterisk":"Info_requiredAsterisk__3kKtY"};